import angular from 'angular';
import { ConfiguracaoDocumentosIndexController } from './index/configuracaodocumentos.index.controller';
import { ConfiguracaoDocumentosListRouting } from './configuracaodocumentos.routes';
import { ConfiguracaoDocumentosModalController } from './modal/configuracaodocumentos.modal.controller';
import { ConfiguracaoDocumentosModalService } from './modal/configuracaodocumentos.modal.service';


export const ConfiguracaoDocumentosModule = angular.module('ConfiguracaoDocumentosModule', ['ui.router.state', ])
    .controller('ConfiguracaoDocumentosIndexController', ConfiguracaoDocumentosIndexController)
    .controller('ConfiguracaoDocumentosModalController', ConfiguracaoDocumentosModalController)
    .service('ConfiguracaoDocumentosModalService', ConfiguracaoDocumentosModalService)
    .config(ConfiguracaoDocumentosListRouting)
    .name;
